import React, { Component } from "react"
import { debtsRange, yesConsiderNo } from '../../variables/ComboValues'
import { updateElement } from "../Tree/Utils.js"
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'

// export only for translation
export const  DebtsStatus_microLegend = {
    "debts_total": "מה גובה החובות שלכם, לא כולל משכנתא?",
    "debts_range": "מהו טווח החובות?",
    "debts_bankropt": "נמצאים בהליך פשיטת רגל?",
    "debts_comment": "הערות"
}

export class FamilyDebtsStatus extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data }
      this.onSaveTable = this.onSaveTable.bind(this)
      this.handleProductTable = this.handleProductTable.bind(this)
    }
    
    handleProductTable(evt) {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp})
    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(familyPostId, this.state.products, subTableId, "group", inUpdate, mbouser )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      //console.log("Family general this.state.products=", this.state.products)
      // console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            headerColumns = {[ "debts_total", "debts_range", "debts_bankropt", "debts_comment"]}
            tableTitle = {tableTitle} 
            products={this.state.products} 
          />
      )
    }
  }
  /*   class SearchBar extends Component { moved to file */
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable } = this.props
      var buttonStyle = {marginRight: '0'}
      // console.log("General - products", products)
      
      var product = ""
      var cellData = []
      if (typeof products !== "undefined"){
          product = products
          cellData=[{
            type: "text",
            name: "debts_total",
            value: product.debts_total,
            id: product.id,
            style: {width: "160px"},
            edit: true
          },{
            type: "select",
            options: debtsRange, // ["אין לנו חובות","עד 50,000 ש''ח","עד 500,000 ש''ח","מעל 500,000 ש''ח"],
            name: "debts_range",
            value: product.debts_range,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "select",
            options: yesConsiderNo, // ["כן","שוקלים זאת","לא"],
            name: "debts_bankropt",
            value: product.debts_bankropt,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "textarea",
            name: "debts_comment",
            value: product.debts_comment,
            id: product.id,
            style: {width: "300px"},
            edit: true
          }]  

      }
      return (
        <div className="yahav-modal">
            <h2 className="text-right">{tableTitle}</h2>
            
            <button style={buttonStyle} type="button"  className="btn btn-success pull-left" onClick={onSaveTable}>עדכון</button>
            {/*height1200*/}
            <div className="mynewdivform">
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    product={product} 
                    cd={cellData}
                    />
            </div>
        </div>
      )
    }
  }

class ProductRow extends React.PureComponent {
    
    render() {
      const {onProductTableUpdate, cd} = this.props
      var key = 0;
      if (cd === "undefined" || !cd.length)
        return (<h4>קבוצת השדות לא מוגדרות במאגר המידע<br/>כנראה בעיה במעבר מאינטייק למשפחה</h4>)
    //console.log("ProductRow = cd=", cd)
      return (
        <div className="eachRow" >
          {cd.map(cellInfo => {
              return (<EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} cellData={cellInfo} /> )
          })}
  
        </div>
      )
  
    }
  
  }
  
  class EditableFormCell extends React.PureComponent {
    render() {
        const tp = this.props
        const tpc = tp.cellData
        if (tpc.type === "select"){
          return(
            <div className="form-cell-box-inline">
              <label  htmlFor={tpc.id}>{DebtsStatus_microLegend[tpc.name]}</label><br />
              <SelectF tp={tp} tpc={tpc} overstyle={{verticalAlign : 'top'}}  />
            </div>
          )
        }
        if (tpc.type === "textarea"){
          return(
            <div className="form-cell-box-inline">
              <label  htmlFor={tpc.id}>{DebtsStatus_microLegend[tpc.name]}</label><br />
              <TextareaF tp={tp} tpc={tpc} />
            </div>
          )
        }
        return (
          <div className="form-cell-box-inline">
            <label  htmlFor={tpc.id}>{DebtsStatus_microLegend[tpc.name]}</label><br />
            <InputF tp={tp} tpc={tpc} />
          </div>
        )
  
    }
  }
